import { render, staticRenderFns } from "./PlayerGiftReceived.vue?vue&type=template&id=355f4ac2&scoped=true&"
import script from "./PlayerGiftReceived.vue?vue&type=script&lang=js&"
export * from "./PlayerGiftReceived.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "355f4ac2",
  null
  
)

export default component.exports